import { render, staticRenderFns } from "./invoicesTable.vue?vue&type=template&id=2878f83e&"
import script from "./invoicesTable.vue?vue&type=script&lang=ts&"
export * from "./invoicesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports